import { devtools, persist } from "zustand/middleware";
import { immer } from "zustand/middleware/immer";
import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

export type CallIntroStep = "CustomerInfoCollection" | "ProductCollection" | "IntroFlowCompleted";
export interface CallIntroProps {
    stepHistory: CallIntroStep[];
    currentStep: CallIntroStep;
    pushStep: (step: CallIntroStep) => void;
    popStep: VoidFunction;
    resetSteps: VoidFunction;
}
const initialStep = "CustomerInfoCollection";
export const useCallIntroStore = createWithEqualityFn<CallIntroProps>()(
    persist(
        immer(
            devtools((set) => ({
                stepHistory: [initialStep],
                currentStep: initialStep,
                pushStep: (step: CallIntroStep) =>
                    set(
                        (state) => {
                            state.stepHistory.push(step);
                            state.currentStep = step;
                        },
                        false,
                        "pushStep",
                    ),
                popStep: () =>
                    set(
                        (state) => {
                            if (state.stepHistory.length > 1) {
                                state.stepHistory.pop();
                                state.currentStep = state.stepHistory[state.stepHistory.length - 1];
                            }
                        },
                        false,
                        "popStep",
                    ),
                resetSteps: () => set({ stepHistory: [initialStep], currentStep: initialStep }, false, "resetSteps"),
            })),
        ),
        { name: "call-intro-flow-store", skipHydration: true },
    ),
    shallow,
);
